import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {},
  state: {
    inPingworthNet: false,
    currentAdmin: JSON.parse(window.localStorage.getItem('user')), // 当前用户
    developer: JSON.parse(window.localStorage.getItem('user')) && JSON.parse(window.localStorage.getItem('user')).developer,
    developerChecked: localStorage.developerChecked === 'true',
  },
  mutations: {
    changeInPingworthNet(state, flag) {
      state.inPingworthNet = flag
    },
    changeDeveloperChecked (state,flag) {
      state.developerChecked = flag
    },
    INIT_WORKER(state, admin) {
      state.currentAdmin = admin
      state.developer = admin.developer
    }
  },
  actions: {
    INIT_WORKER({ commit }, data) {
      commit('INIT_WORKER', data)
    },
    logout({ commit, state }) {
      return new Promise((resolve, reject) => {
        window.localStorage.clear()
        window.sessionStorage.clear()
        resolve()
      })
    },
  },
  getters
})



// WEBPACK FOOTER //
// ./src/store/index.js